const sortAlphabetically = (array) =>
  [...array].sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));

export default sortAlphabetically;
